
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","viewBox":"0 0 21 20","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.364 1.551l3.648 3.536-1.673 1.622-3.649-3.536 1.674-1.622zm.903 5.508l-2.913-2.824a.6.6 0 00-.85 0l-9.53 9.177c-.06.059-.06.117-.121.176v.06L1.396 17.94c-.06.236 0 .47.121.588a.56.56 0 00.425.177c.06 0 .122 0 .182-.059l4.431-1.412h.061c.06 0 .121-.058.182-.117l9.47-9.177a.626.626 0 000-.882zM2.913 17.176l.79-2.294 1.578 1.53-2.368.765zm3.46-1.352l-2.124-2.06 8.619-8.293 2.124 2.058-8.619 8.294z"}})])
          )
        }
      }
    